import React, { Fragment } from "react";
import cx from "classnames";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import HeaderLogo from "../AppLogo";
import { Breadcrumb, BreadcrumbItem} from "reactstrap";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import UserBox from "./Components/UserBox";
import InputSelect from "./Components/InputSelect";
import Cart from "./Components/Cart";
import FilterBy from "./Components/FilterBy";
import SweetAlert from 'react-bootstrap-sweetalert';
import Portal from "../../Utils/portals";
import util from "../../Utils/util";
import Card_view from "./Components/Card_view";
class Header extends React.Component {

  render() {
    let {
      headerBackgroundColor,
      enableMobileMenuSmall,
      enableHeaderShadow,
    } = this.props;

    return (
      <Fragment>
        <TransitionGroup>
          <CSSTransition component="div"
            className={cx("app-header", headerBackgroundColor, {
              "header-shadow": enableHeaderShadow,
            })}
            appear={true} timeout={1500} enter={false} exit={false}>
            <div>
              <HeaderLogo />
              <div className={cx("app-header__content", {
                "header-mobile-open": enableMobileMenuSmall,
              })}>
                <div className="app-header-left mt-3">
                  <Breadcrumb>
                    <BreadcrumbItem>
                      <Link to="/dashboard">
                        <FontAwesomeIcon icon={faHome} style={{ color: '#1e90ff' }}/>
                      </Link>
                    </BreadcrumbItem>
                    {this.props.items?.map((item, k) => (
                      <BreadcrumbItem key={k}>
                        <span className="text-capitalize">{item}</span>
                      </BreadcrumbItem>
                    ))}
                  </Breadcrumb>

                  {/* <SearchBox /> */}
                  {/* <MegaMenu /> */}
                </div>
                <div className="app-header-right">
                  {/* <HeaderDots /> */}
                  <Card_view />
                  {util?.getIsStaff() === "staff" && (
                    <>
                    <FilterBy />                      
                    </>
                  )}
                  <InputSelect />
                  <Cart />
                  <UserBox />
                  {/* <UserBox /> */}

                </div>
              </div>


              {this.props?.show && (
                <Portal id="sweet-alert-portal">
                  <SweetAlert r title={this.props?.errorMsg || "NETWORK ERROR"} show={this.props?.show}
                    type="danger" onConfirm={(e) => { window.location.replace("https://leadfuzionlists.com/") }}
                    confirmBtnText="Contact With Us" confirmBtnBsStyle="info" />
                </Portal>
              )}
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
